import React from "react";
import Footer from "../Footer";
import { useLocation } from "react-router-dom";

const FooterContainer = () => {
  return <Footer />;
};

export default FooterContainer;
